import {
  GetAiAgentsPayload,
  GetAiAgentAlertsListPayload,
} from 'app/modules/aiAgents/requests';

const BASE = 'aiAgents';
const AI_AGENTS_ENDPOINT = '/ai-agents';
export const AI_AGENTS_QUERY_KEYS = {
  list: (payload: GetAiAgentsPayload) => [
    ...AI_AGENTS_QUERY_KEYS.listAll(),
    payload,
  ],
  listAll: () => [BASE, 'list'],
  aggregateMetrics: () => [BASE, 'metrics'],
  aggregateMetricsPerAgent: (agentId: number) => [BASE, agentId, 'metrics'],
  details: (agentId: number) => [BASE, agentId, 'details'],
  taskList: (agentId: number) => [BASE, agentId, 'tasks'] as const,
  l2CustomTaskMetadata: () => [BASE, 'l2-custom-task-metadata'] as const,
  narrativeTasksOutput: (agentId: number) => [BASE, agentId, 'tasks', 'output'],
  getNarrativeInstructions: (
    agentId: number,
    instructionType: string = 'DEFAULT',
  ) => [BASE, 'get-narrative-instructions', agentId, instructionType],
  aiAlertsList: (agentId: number, payload: GetAiAgentAlertsListPayload) => [
    BASE,
    agentId,
    'alerts',
    'list',
    payload,
  ],
} as const;

export const AI_AGENTS_ENDPOINTS = {
  list: () => `${AI_AGENTS_ENDPOINT}/list`,
  aggregateMetrics: () => `${AI_AGENTS_ENDPOINT}/metrics`,
  aggregateMetricsPerAgent: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/metrics`,
  details: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}`,
  create: () => `${AI_AGENTS_ENDPOINT}/create`,
  edit: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}/edit`,
  archive: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}/archive`,
  restore: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}/restore`,
  taskList: (agentId: number) => `${AI_AGENTS_ENDPOINT}/${agentId}/tasks`,
  l2CustomTaskMetadata: () => `${AI_AGENTS_ENDPOINT}/l2-custom-task-metadata`,
  associateInitialTasks: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/associate-initial-tasks`,
  narrativeTasksOutput: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/tasks-output`,
  getNarrativeInstructions: (agentId: number, instructionType: string) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/instructions/${instructionType}`,
  generateNarrativePreview: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/instructions`,
  saveNarrativeInstructions: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/instructions`,
  deactivateNarrativeInstructions: (
    agentId: number,
    narrativeInstructionsId: number,
  ) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/narrative/instructions/${narrativeInstructionsId}`,
  aiAlertsList: (agentId: number) =>
    `${AI_AGENTS_ENDPOINT}/${agentId}/alerts/list`,
} as const;
